import * as React from "react";
import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={12}
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M14.75.724c.372.361.38.955.02 1.326l-9.262 9.528a.94.94 0 0 1-1.369-.026L.59 7.611a.938.938 0 0 1 1.394-1.255l2.878 3.197 8.563-8.81A.94.94 0 0 1 14.75.724"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheck;
